import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import { getIsMobile } from 'src/store/view/selectors';

import AboutRoomPopup from '../../../../components/AboutRoomPopup';
import { closeRoomPopupAction } from '../../store/actions/room-popup';
import { getRoomInfo } from '../../store/selectors/package';
import { getRoomPopupIsOpened } from '../../store/selectors/room-popup';

const mapStateToProps = (state) => ({
  opened: getRoomPopupIsOpened(state),
  room: getRoomInfo(state),
  isMobile: getIsMobile(state),
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closeRoomPopupAction()),
});

const connector = connect(mapStateToProps, mapDispatchToProps);
export type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(AboutRoomPopup);
